export const toActionType = (creator: { toString(): string }): string =>
  creator.toString();
